import React, { useEffect, useRef, useState } from "react";
import "./App.css";
import { IFrameHelper } from "../utils/Helper";
import { Route, Routes, useNavigate } from "react-router-dom";
import { newRoutes, routes } from "./routes";
import {
  setPropertyId,
  setSession,
  setSessionId,
  setVisitor,
  setVisitorId,
  setWidgetId,
  setWidgetSettings,
} from "../store/reducers/visitorReducer";
import { useDispatch, useSelector } from "react-redux";
import { getSessionRef, getVisitorRef, getPropertyRef, getWidgetRef } from "../firebase/collectionReference";
import { onSnapshot } from "firebase/firestore";
import { getVisitor } from "../firebase/query";

const App = () => {
  const sessionId = useSelector((state) => state.visitor.sessionId);
  const visitorId = useSelector((state) => state.visitor.visitorId);
  const visitor = useSelector((state) => state.visitor.visitor);
  const propertyId = useSelector((state) => state.visitor.propertyId);
  const widgetId = useSelector((state) => state.visitor.widgetId);
  const unreadMsgsCount = useSelector((state) => state.visitor.unreadMsgsCount);

  // State variable to store the active color
  const [activeColor, setActiveColor] = useState("rgb(0, 87, 255)");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const registerListeners = () => {
    window.addEventListener("message", (e) => {
      if (typeof e.data === "string" && !e.data.includes("webpackHot")) {
        let message = JSON.parse(e.data);
        if (message.event === "set-visitor") {
          recordVisitor(message);
        } else if (message.event === "navigate-to") {
          navigate(message.to);
        }
      }
    });
  };

  const recordVisitor = async (message) => {
    dispatch(setSessionId(message.session));
    dispatch(setPropertyId(message.propertyId));
    dispatch(setWidgetId(message.widgetId));
    dispatch(setVisitorId(message.identifier));
    const visitor = await getVisitor(message?.identifier);
    dispatch(setVisitor(visitor));
  };

  useEffect(() => {
    setTimeout(() => {
      sendChatLoaded();
      registerListeners();
    }, 500);
  }, []);

  useEffect(() => {
    let unSubSession = null;
    let unSubVisitor = null;
    if (sessionId && visitorId) {
      const visitorRef = getVisitorRef(visitorId);
      const sessionRef = getSessionRef(visitorRef, sessionId);
      unSubVisitor = onSnapshot(visitorRef, (snapshot) => {
        const visitor = { id: snapshot.id, ...snapshot.data() };
        if (visitor.isBanned)
          IFrameHelper.sendMessage({
            event: "banVisitor",
          });
      });

      unSubSession = onSnapshot(sessionRef, (snapshot) => {
        const session = { id: snapshot.id, ...snapshot.data() };
        // Do not auto-resetSession when sessionEnded — that races with page refresh
        // (socket falsely ends the session) and wipes an active conversation.
        // resetSession is sent explicitly from feedback submit / end chat / ban.
        if (!session?.sessionEnded && session?.chatStarted) {
          if (visitor?.isNewMessage) {
            let cookieUnreadCount = unreadMsgsCount;

            IFrameHelper.sendMessage({
              event: "messageReceive",
              data: {
                body: session.startMessage,
                id: session.startMessageId,
                unreadMsgsCount: cookieUnreadCount
                  ? JSON.parse(cookieUnreadCount)
                  : 0,
              },
            });
          }
        }
        dispatch(setSession(session));
      });
    }
    return () => {
      if (unSubSession) unSubSession();
      if (unSubVisitor) unSubVisitor();
    };
  }, [sessionId, visitorId]);

  useEffect(() => {
    if (!propertyId || !widgetId) return undefined;

    const propertyRef = getPropertyRef(propertyId);
    const widgetRef = getWidgetRef(propertyRef, widgetId);
    const unsub = onSnapshot(
      widgetRef,
      (snapshot) => {
        if (!snapshot.exists()) return;
        const res = { ...snapshot.data(), id: snapshot.id };
        setActiveColor(res?.appearance?.color);
        dispatch(setWidgetSettings(res));
      },
      (err) => console.log(err.message)
    );
    return () => unsub();
  }, [propertyId, widgetId, dispatch]);

  // const markMessageReadStatus = async (message) => {
  //   const visitorRef = doc(db, Collections.visitors, message.identifier);
  //   if (message.lastMessageId) {
  //     const sessionRef = doc(visitorRef, Collections.sessions, message.session);
  //     const activityRef = doc(
  //       sessionRef,
  //       Collections.activities,
  //       message.lastMessageId
  //     );
  //     await updateDoc(activityRef, {
  //       readStatus: 1,
  //       readAt: serverTimestamp(),
  //     });
  //   }
  //   await updateDoc(visitorRef, {
  //     lastMessageReadStatus: 1,
  //   });
  // };
  const sendChatLoaded = () => {
    IFrameHelper.sendMessage({
      event: "chatLoaded",
    });
  };

  return (
    <div style={{ "--active-color": activeColor }}>
      <Routes>
        {newRoutes.map((route) => (
          <Route key={route.key} path={route.path} element={route.element} />
        ))}
      </Routes>
    </div>
  );
};

export default App;
